import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { GetAudiencePricingDocument } from '../../../../graphql/query/audiences/GetAudiencePricing.generated';
import { MatchingOperator } from '../constants';
import type { AudienceForm } from '../types';
import { filterNormalizedEmptyGroups } from '../utils/filterNormalizedEmptyGroups';
import { hasSegmentDataInIncludes } from '../utils/hasSegmentDataInIncludes';

export const useSummaryAlert = () => {
  const observableNormalizedDefinition = useWatch<AudienceForm, 'normalized_definition'>({
    name: 'normalized_definition',
  });
  const observableAccountId = useWatch<AudienceForm, 'account_id'>({
    name: 'account_id',
  });

  const filteredDefinition = filterNormalizedEmptyGroups(observableNormalizedDefinition);

  const { data } = useQuery(GetAudiencePricingDocument, {
    variables: {
      accountId: observableAccountId,
      normalizedDefinition: filteredDefinition,
    },
    skip: !observableAccountId || !hasSegmentDataInIncludes(observableNormalizedDefinition),
  });

  const hasIntersectGroupsWithDifferentAccountId = useMemo(() => {
    return (
      data?.computePricing?.operator === MatchingOperator.INTERSECTION &&
      data?.computePricing?.pricing_by_org.length > 1
    );
  }, [data]);

  return hasIntersectGroupsWithDifferentAccountId;
};
